<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- titulo y boton crear -->
    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col cols="12" class="d-flex justify-end align-center">
        <!-- <v-autocomplete
          style="max-width: 200px"
          @change="getAllGradosPaises(id_pais_search)"
          v-model="id_pais_search"
          label="País"
          :items="paisFiltro"
          item-value="id"
          item-text="nombre_pais"
          autocomplete="off"
        >
        </v-autocomplete> -->
        <Tablebuttoncomp
          normalButton
          textButton="Crear grado"
          iconBut="fas fa-plus"
          @click="addItem"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ComundataTablecomp
          :headers="Gradosheaders"
          :items="Grados"
          placeholderTextsearch="Buscar grados"
          rowsPerPageText="Grados por página:"
          noResultsText="Sin g}rados por Mostrar"
          whitSearch
        >
          <slot>
            <!-- filtros para la tabla -->
            <v-row dense>
              <v-col cols="12" md="4" sm="6">
                <AutocompleteComp
                  @change="getAllGradosPaises(id_pais_search)"
                  v-model="id_pais_search"
                  textLabel="País"
                  :items="paisFiltro"
                  item-value="id"
                  item-text="nombre_pais"
                />
              </v-col>
            </v-row>
          </slot>

          <template v-slot:nivel="{ item }">
            <div class="chip" :style="{ background: item.color_nivel }">
              {{ item.desc_nivel }}
            </div>
          </template>

          <template v-slot:action_editar="{ item }">
            <Tablebuttoncomp
              v-if="componenteEvento.editar_submodulo"
              @click="editItem(item)"
              editButton
              tooltipText="Editar grado"
            />
          </template>
          <template v-slot:action_borrar="{ item }">
            <Tablebuttoncomp
              v-if="componenteEvento.borrar_submodulo"
              @click="deleteConfirm(item)"
              tooltipText="Borrar grado"
              deleteButton
            />
          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>

    <!-- modal crear grado -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="dialog" scrollable persistent max-width="450">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row>
              <v-col cols="10">
                {{ formTitle }}
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <v-btn
                  fab
                  dark
                  x-small
                  class="btn_style3"
                  @click="dialog = false"
                  ><v-icon dark>fa-times</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-autocomplete
                  @change="getNivelesPais(editedItem.id_pais)"
                  v-model="editedItem.id_pais"
                  label="País"
                  :items="pais"
                  item-value="id"
                  item-text="nombre_pais"
                  autocomplete="off"
                  :rules="[rul.selectReq]"
                  :readonly="bloquearCampo"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-autocomplete
                  v-model="editedItem.id_nivel"
                  label="Nivel"
                  :items="Niveles"
                  item-text="desc_nivel"
                  item-value="id"
                  autocomplete="off"
                  :rules="[rul.selectReq]"
                  :readonly="bloquearCampo"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="editedItem.desc_grado"
                  label="Nombre"
                  type="text"
                  :rules="[rul.required, rul.max100]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento == 'editar'"
              @click="editGrado(editedItem.id)"
              >Guardar Cambios</v-btn
            >
            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento == 'agregar'"
              @click="addGrado"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-------------------->

    <!-- /////////////////////////////////////////////////////    -->
    <v-dialog v-model="modal_confirmacion" width="450">
      <v-card>
        <v-card-title class="red">
            <span class=" white--text">Eliminar grado</span>
            <v-spacer></v-spacer>
              <v-btn
                fab
                dark
                x-small
                class="btn_style3"
                @click="modal_confirmacion = false"
                ><v-icon dark>fa-times</v-icon></v-btn
              >
        </v-card-title>

        <v-card-text class="text-center black--text pt-10">
          <h3>{{ title_confirm }}</h3>
          <br>
          <p class="subtitle-1">{{ name_confirm }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark  @click="closeConfirm">No</v-btn>
          <v-btn class="btn_block_style2" dark  @click="actionConfirm">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal -->
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapActions, mapMutations, mapGetters } from "vuex";
import { Gradosheaders } from "../../../../helpers/headersTable.js";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import Tablebuttoncomp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";

export default {
  name: "Grados",
  props: ["Grados"],
  components: {
    ComundataTablecomp,
    Tablebuttoncomp,
    AutocompleteComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 4, id_modulo: 4 },
    Gradosheaders,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    paisFiltro: [],
    search: "",

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
    },

    // modal agregar editar grado
    evento: "",
    dialog: false,
    id_pais_search: null,
    pais: [],
    Niveles: [],
    bloquearCampo: false,
    id_nivel: { id: 0, desc_nivel: "" },
    editedItem: [],

    // modal confirmar
    modal_confirmacion: false,
    name_confirm: "",
    title_confirm: "",

    id_delete: null,
    dialog_delete: false,
    name_delete: "",
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar" ? "Crear grado" : "Editar grado";
    },
  },

  created() {
    this.actualizarParamentro();
    this.getPais();

    this.$store.dispatch("nivelesGrados/getAllNiveles");
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    async getPais() {
      try {
        let response = await axios.get(
          "/mantenimiento/paises/paisesConfigurados/"
        );
        this.pais = response.data;

        let objectNew = JSON.parse(JSON.stringify(response.data));

        objectNew.unshift({
          id: null,
          nombre_pais: "TODOS",
        });

        this.paisFiltro = objectNew;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    /////////////////////////////////////////
    limpiarForm() {
      (this.editedItem = {
        id: 0,
        desc_grado: "",
        id_usuario: this.datoLogin.id, //18-02-2020. Robert. Se vincula con el usuario en session.
        id_nivel: 0,
        id_colegio: 0,
        estado: 1,
        ck1: true,
      }),
        (this.bloquearCampo = false);

      // Validar resetear campos al guardar
      this.$refs.formDatos.resetValidation();
    },

    addItem() {
      this.evento = "agregar";
      this.dialog = true;
      this.limpiarForm();
    },

    //************ traer niveles por pais al agregar grado ******/
    async getNivelesPais(id) {
      //this.editedItem.id_nivel = ''

      try {
        let response = await axios.get("/manager/nivelCkOne/pais/" + id);
        this.Niveles = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //-------------Crear  Nuevo Grado------------
    async addGrado() {
      if (this.$refs.formDatos.validate()) {
        let params = this.editedItem;
        //console.log(params)

        try {
          let res = await axios.post("/manager/gradoCkOne/", params);

          if (res.data.messageT == "S") {
            this.getAllGradosPaises(this.id_pais_search);
            this.setEnviarMens({
              tipo: res.data.messageT,
              mensaje: res.data.message,
              tiempo: null,
            });
            this.mensajeConfirmacion();
          }

          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      }
    },

    mensajeConfirmacion() {
      this.modal_confirmacion = true;

      if (this.evento == "agregar") {
        this.title_confirm = "¿Desea agregar otro Grado?";
        this.name_confirm = "";
      }
    },

    ////si la respuesta es no, para agregar mas grados o eliminar
    closeConfirm() {
      if (this.evento == "agregar") {
        this.dialog = false;
        this.limpiarForm();
      }

      this.modal_confirmacion = false;
    },

    //si la respuesta es si para agregar mas grados  o eliminar
    actionConfirm() {
      if (this.evento == "agregar") {
        this.editedItem.desc_grado = "";
        this.modal_confirmacion = false;
      }

      if (this.evento == "borrar") {
        this.deleteGrado();
      }
    },

    //---------obtener datos pàra editar
    editItem(item) {
      this.evento = "editar";
      this.limpiarForm();

      this.editedItem = Object.assign({}, item);
      this.getNivelesPais(item.id_pais);
      this.bloquearCampo = true;

      this.dialog = true;
    },

    //----------------editar Grado ----------------
    async editGrado(id) {
      if (this.$refs.formDatos.validate()) {
        let params = this.editedItem;
        try {
          let res = await axios.put("/manager/gradoCkOne/" + id, params);

          if (res.data.messageT == "S") {
            this.getAllGradosPaises(this.id_pais_search);
            this.dialog = false;
            this.limpiarForm();
          }
          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      }
    },

    // activa la modal para confirmar el borrar el registro
    deleteConfirm(item) {
      this.evento = "borrar";
      this.modal_confirmacion = true;

      this.title_confirm = "¿Está seguro de borrar este registro ?";
      this.name_confirm = `Grado: ${item.desc_grado}`;
      this.id_delete = item.id;
    },

    //------------borrar Grado -------------
    async deleteGrado() {
      try {
        let response = await axios.delete(
          "/manager/gradoCkOne/" + this.id_delete
        );
        this.getAllGradosPaises(this.id_pais_search);

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: null,
        });
        this.modal_confirmacion = false;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    // funcion que trae todos los paises para filtrar los grados, esta ubicada en NivelesyGrados.vue
    getAllGradosPaises(id) {
      this.$emit("getGradosPaises", id);
    },
  },
};
</script>

<style scoped>
.chip {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 15px;
  color: #ffffff;
}
</style>
